import { render, staticRenderFns } from "./HbTabs.vue?vue&type=template&id=73d1c9c2&scoped=true"
import script from "./HbTabs.vue?vue&type=script&lang=js"
export * from "./HbTabs.vue?vue&type=script&lang=js"
import style0 from "./HbTabs.vue?vue&type=style&index=0&id=73d1c9c2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d1c9c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73d1c9c2')) {
      api.createRecord('73d1c9c2', component.options)
    } else {
      api.reload('73d1c9c2', component.options)
    }
    module.hot.accept("./HbTabs.vue?vue&type=template&id=73d1c9c2&scoped=true", function () {
      api.rerender('73d1c9c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/hubee/HbTabs.vue"
export default component.exports